/* tslint:disable */
import * as Types from '../../../../../../graphql-api/gql-api-interfaces';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type AccountDetailsQueryVariables = Types.Exact<{
  accountId: Types.Scalars['String']['input'];
}>;


export type AccountDetailsQuery = { account: { accountId: string, accountTypeIds?: Array<string | null> | null, authorizedForFutureOrder?: boolean | null, authorizedForConsignmentOrder?: boolean | null, externalId: string, name: string, domainId?: string | null, currency?: string | null, properties?: any | null, brandOrganisations?: Array<{ id: string, brandId: string, brandOrganisationId: string, displayName: string, isEnabled?: boolean | null, nowInventoryLeadTime?: string | null } | null> | null, sites?: Array<{ isMarketSite?: boolean | null, logoUrl?: string | null, order?: number | null, siteId: string, brandId?: string | null, subSiteRequired?: boolean | null, title?: string | null, subSites?: Array<{ customUrl?: string | null, isFilter?: boolean | null, isBrandSelectorVisible?: boolean | null, subSiteId: string, logoUrl?: string | null, title?: string | null } | null> | null } | null> | null, shipToAddresses: Array<{ accountId: string, addressId: string, realAddressId?: string | null, name: string, state?: string | null, street?: string | null, country: string, city?: string | null, countryCode?: string | null }>, features: { useRrpForDiscount: boolean, allowAlternativeAddress: boolean, erpDrivenAlternativeDeliverAddress: boolean } } };

export const AccountDetailsDocument = gql`
    query AccountDetails($accountId: String!) {
  account(accountId: $accountId) {
    accountId
    accountTypeIds
    authorizedForFutureOrder
    authorizedForConsignmentOrder
    brandOrganisations {
      id
      brandId
      brandOrganisationId
      displayName
      isEnabled
      nowInventoryLeadTime
    }
    externalId
    name
    domainId
    currency
    sites {
      isMarketSite
      logoUrl
      order
      siteId
      brandId
      subSiteRequired
      subSites {
        customUrl
        isFilter
        isBrandSelectorVisible
        subSiteId
        logoUrl
        title
      }
      title
    }
    shipToAddresses {
      accountId
      addressId
      realAddressId
      name
      state
      street
      country
      city
      countryCode
    }
    features {
      useRrpForDiscount
      allowAlternativeAddress
      erpDrivenAlternativeDeliverAddress
    }
    properties
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AccountDetailsGQL extends Apollo.Query<AccountDetailsQuery, AccountDetailsQueryVariables> {
    document = AccountDetailsDocument;
    client = 'accounts';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }